import { IonIcon } from "@ionic/react";
import { closeSharp } from "ionicons/icons";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useOutletContext } from "react-router";
import styled, { css } from "styled-components";
import ProductObj from "../../../../OBJRep/Product";
import ProductStyles from "../../../../OBJRep/ProductStyles";
import {
  loadProductImages,
  searchUserProducts,
} from "../../../../services/UserProducts";
import {
  copyProductPropertiesWithoutStyles,
  scrollIntoStart,
} from "../../../../services/Utils";
import Button from "../../../sharable/ActionButton";
import { Image } from "../../../sharable/EncarteProduct/EncarteProduct.styles";
import { Input } from "../../../sharable/InputStyle";
import { ListProduct } from "../../../sharable/ListProduct";
import Loading from "../../../sharable/Loading";
import PaginationButton from "../../../sharable/PaginationButton";
import PopUp from "../../../sharable/PopUp";
import PremiumContentProtectiveLayer from "../../../sharable/PremiumContentProtectiveLayer";
import { ProductForm } from "../../../sharable/ProductForm";
import { DEFAULT_PRICE_PUBLIC_LOCATION } from "../../CanvasViewer/EncarteConstants";
import WorkspaceContext from "../../WorkspaceContext";
import { MenuDescription, MenuTitle } from "../Toolbar";

const Container = styled.div`
  position: relative;
  width: 100%;
  height: calc(100vh - 8.4rem);
  overflow-y: scroll;
  overflow-x: hidden;

  .query-input {
    width: 100%;
    margin-bottom: 3rem;
  }

  ${({ isAccountPremium }) =>
    !isAccountPremium &&
    css`
      overflow-y: hidden;
      overflow-x: hidden;
      height: 100vh;
      main {
        filter: blur(3px);
      }
    `}

  .menu-title {
    margin-top: 3rem;
  }
`;

const List = styled.ul`
  gap: 3rem;
  width: 100%;
  position: relative;
  overflow: auto;

  .loading-message-wrapper {
    min-width: 100%;
    min-height: 10rem;
  }
`;

const ProductFormWrapper = styled.div`
  overflow: hidden;
  margin: 1.6rem 0;
  position: relative;

  .image-span {
    text-align: center;
  }
  .close-form-span {
    font-size: 1.2rem;
    border: 1px solid #fff;
    padding: 0.4rem 0.8rem;
    width: 40%;
    justify-content: space-around;
    margin-bottom: 1.2rem;
    font-weight: bold;
    transition: all 300ms;
    cursor: pointer;
    &:hover {
      background-color: #d97706;
      border-color: transparent;
    }
  }

  animation: $;
`;

const ProductButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.4rem;

  .product-count {
    font-size: 1.4rem;
    display: inline-block;
    margin-bottom: 2rem;
  }
`;

const UPLOAD_MODE = "upload";
const UPDATE_MODE = "update";

const GRID_FULL_MESSAGE =
  "Sua grade de produtos está cheia! Para poder adicionar mais produtos escolha uma grade com uma quantidade maior de produtos.";
const GRID_FULL_MESSAGE_v2 = "Sua grade de produtos está cheia!";

const PRODUCT_ALREADY_EXISTS_MESSAGE =
  "Esse produto já foi inserido no encarte. Encartes não podem possuir itens duplicados";
const PRODUCT_NOT_DELETABLE_MESSAGE =
  "Esse produto não pode ser deletado pois está sendo utilizado em outros encartes!";
const PRODUCT_CREATED_SUCCESSFULLY_MESSAGE = "Produto criado com sucesso!";
const PRODUCT_UPDATED_SUCESSFULLY_MESSAGE = "Produto atualizado com sucesso!";
const SERVER_BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
export default function MyProductsView() {
  const { token, isAccountPremium } = useOutletContext();
  const {
    products,
    onUserProductsPageChange,
    grid,
    userProductsPage,
    maxProducts,
    onProductsChange,
  } = useContext(WorkspaceContext);
  const [currentMode, setCurrentMode] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState();
  const [isUserTyping, setIsUserTyping] = useState(false);
  const [productNameInputSearch, setProductNameInputSearch] = useState("");
  const [selectedProductImageSearch, setSelectedProductImageSearch] = useState(
    [],
  );
  const [userProductsSearchPage, setUserProductsSearchPage] = useState(null);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const mainRef = useRef();
  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpMessage, setPopUpmessage] = useState();
  const onListProductClick = (product) => {
    let productExists = false;
    let hasGridSpaceAvailable = false;
    let gridSpaceIndex = undefined;
    for (let i = 0; i < products.length; i++) {
      if (products[i].name === product.name) productExists = true;
      if (products[i].name.toLowerCase().includes("nome do produto")) {
        hasGridSpaceAvailable = true;
        gridSpaceIndex = i;
        break;
      }
    }
    if (productExists) {
      setShowPopUp(true);
      setPopUpmessage(PRODUCT_ALREADY_EXISTS_MESSAGE);
      return;
    } else if (!hasGridSpaceAvailable && products.length < maxProducts) {
      const productsCopy = [...products];
      product.id = products.length;
      product.styles = ProductStyles();
      product.styles.priceStyleTmp = DEFAULT_PRICE_PUBLIC_LOCATION;
      productsCopy.push(product);
      onProductsChange([...productsCopy]);
      return;
    } else if (products.length >= maxProducts && !hasGridSpaceAvailable) {
      setPopUpmessage(GRID_FULL_MESSAGE_v2);
      setShowPopUp(true);
    }
    if (hasGridSpaceAvailable) {
      product.id = gridSpaceIndex;
      products[gridSpaceIndex] = copyProductPropertiesWithoutStyles(
        product,
        products[gridSpaceIndex],
      );
    } else if (products.length < maxProducts) {
      product.styles = ProductStyles();
      product.styles.priceStyleTmp = DEFAULT_PRICE_PUBLIC_LOCATION;
      products.push(product);
    }
    onProductsChange([...products]);
  };
  const watchUserTyping = useEffect(() => {
    setIsUserTyping(true);
    if (productNameInputSearch?.length < 3 && userProductsSearchPage != null) {
      setUserProductsSearchPage(null);
      return;
    }

    const timeout = setTimeout(() => {
      if (!productNameInputSearch || productNameInputSearch?.length < 3) {
        return;
      }

      setIsUserTyping(false);

      searchProductsCallBack(
        userProductsSearchPage ? userProductsSearchPage.pageNumber + 1 : 0,
      );
    }, 1200);
    return () => clearTimeout(timeout);
  }, [productNameInputSearch]);

  const onCreateNewProduct = async () => {
    if (!selectedProduct.name) return;
    const res = await fetch(`${SERVER_BASE_URL}products`, {
      headers: { Authorization: token, "Content-Type": "application/json" },
      method: "POST",
      body: JSON.stringify(selectedProduct),
    });
    if (res.ok) {
      setSelectedProduct(ProductObj());
      setShowPopUp(true);
      setPopUpmessage(PRODUCT_CREATED_SUCCESSFULLY_MESSAGE);
    }
  };
  const onProductImageClick = (image, object) => {
    if (!image) return;
    object.imageURL = image.url;
    object.displayUrl = image.displayUrl;
    setSelectedProduct({ ...object });
  };
  const onProductInfoChange = (prop, value, object) => {
    object[prop] = value;
    setSelectedProduct({ ...object });
  };

  const onProductDelete = async (product) => {
    const res = await fetch(`${SERVER_BASE_URL}products/${product.id}`, {
      headers: { Authorization: token },
      method: "DELETE",
      body: JSON.stringify(selectedProduct),
    });
    if (res.ok) {
      setShowPopUp(true);
      const userProductsPageRemainingProducts =
        userProductsPage.products.filter((p) => p.id !== product.id);
      userProductsPage.products = userProductsPageRemainingProducts;
      onUserProductsPageChange({ ...userProductsPage });

      if (userProductsSearchPage) {
        const userProductsSearchPageRemainingProducts =
          userProductsSearchPage.products.filter((p) => p.id !== product.id);
        userProductsSearchPage.products =
          userProductsSearchPageRemainingProducts;
        onUserProductsPageChange({ ...userProductsSearchPage });
      }
      setPopUpmessage("Produto deletado com êxito");
    } else if (res.status === 500) {
      setShowPopUp(true);
      setPopUpmessage(PRODUCT_NOT_DELETABLE_MESSAGE);
    }
  };

  const onProductUpdate = async () => {
    const res = await fetch(`${SERVER_BASE_URL}products`, {
      headers: { Authorization: token, "Content-Type": "application/json" },
      method: "PUT",
      body: JSON.stringify(selectedProduct),
    });
    if (res.ok) {
      setShowPopUp(true);
      setPopUpmessage(PRODUCT_UPDATED_SUCESSFULLY_MESSAGE);
      updateProductOnEncarte();
      updateProductOnUserProductsPage();
    } else {
      setShowPopUp(true);
      setPopUpmessage("Não foi possível atualizar o produto :(");
    }
  };

  const updateProductOnEncarte = () => {
    const encarteUpdatedProducts = products.map((p) => {
      if (p.id === selectedProduct.id)
        p = copyProductPropertiesWithoutStyles(selectedProduct, p);
      return p;
    });
    onProductsChange(encarteUpdatedProducts);
  };

  const updateProductOnUserProductsPage = () => {
    const userProductsPageUpdatedProducts = userProductsPage.products.map(
      (p) => {
        if (p.id === selectedProduct.id)
          p = copyProductPropertiesWithoutStyles(selectedProduct, p);
        return p;
      },
    );
    userProductsPage.products = userProductsPageUpdatedProducts;
    onUserProductsPageChange({ ...userProductsPage });
  };

  const loadUserProductsFirstPage = useEffect(() => {
    if (!userProductsPage) loadUserProducts(0);
  }, []);

  const loadUserProducts = useCallback(
    async (pageNumber) => {
      setLoadingProducts(true);
      const params = new URLSearchParams();
      params.append("pageNumber", pageNumber);
      params.append("pageSize", 10);

      const res = await fetch(
        `${SERVER_BASE_URL}products?${params.toString()}`,
        {
          headers: {
            Authorization: token,
          },
        },
      );

      const newPage = await res.json();

      const newProducts = await loadProductImages(token, newPage.products); //Aggregates new products to already loaded products if first page is was loaded
      if (userProductsPage)
        newPage.products = [...userProductsPage.products, ...newProducts];
      onUserProductsPageChange({ ...newPage });
      setLoadingProducts(false);
    },
    [userProductsPage],
  );

  const searchProductsCallBack = useCallback(
    async (pageNumber) => {
      setLoadingProducts(true);
      try {
        const newPage = await searchUserProducts(
          token,
          productNameInputSearch,
          pageNumber,
          10,
          userProductsSearchPage,
        );
        const newProducts = await loadProductImages(token, newPage.products);
        if (userProductsSearchPage)
          newPage.products = [
            ...userProductsSearchPage.products,
            ...newProducts,
          ];
        else newPage.products = [...newProducts];
        setUserProductsSearchPage({ ...newPage });
        setLoadingProducts(false);
      } catch (error) {
        console.log(error);
      }
    },
    [token, productNameInputSearch, userProductsSearchPage],
  );

  return (
    <Container
      isAccountPremium={isAccountPremium}
      className="menu-view-container"
    >
      {!isAccountPremium && <PremiumContentProtectiveLayer />}
      <main className="main-view" ref={mainRef}>
        <MenuDescription>
          Você pode criar encartes adicionando produtos já cadastrados aqui!
        </MenuDescription>
        <PopUp
          setShowPopUp={setShowPopUp}
          text={popUpMessage}
          showPopUp={showPopUp}
          buttonText={"Ok"}
          position="fixed"
          top="0rem"
          right="2rem"
        />
        {!currentMode && (
          <Button
            $NoBgColor
            $fullWidth
            text="Registrar novo produto +"
            color="#fff"
            width="calc(100% - 3px)"
            action={() => {
              setSelectedProduct(ProductObj());
              setCurrentMode(UPLOAD_MODE);
            }}
            size="1.4"
          />
        )}

        {currentMode === UPLOAD_MODE ? (
          <UploadForm
            onProductImageClick={onProductImageClick}
            selectedProductImageSearch={selectedProductImageSearch}
            selectedProduct={selectedProduct}
            setCurrentMode={setCurrentMode}
            setSelectedProductImageSearch={setSelectedProductImageSearch}
            onCreateNewProduct={onCreateNewProduct}
            setSelectedProduct={setSelectedProduct}
            onProductInfoChange={onProductInfoChange}
          />
        ) : (
          currentMode === UPDATE_MODE && (
            <UpdateForm
              onProductImageClick={onProductImageClick}
              selectedProductImageSearch={selectedProductImageSearch}
              selectedProduct={selectedProduct}
              setCurrentMode={setCurrentMode}
              setSelectedProductImageSearch={setSelectedProductImageSearch}
              onProductUpdate={onProductUpdate}
              setSelectedProduct={setSelectedProduct}
              onProductInfoChange={onProductInfoChange}
            />
          )
        )}

        <MenuTitle className="menu-title">Meus produtos</MenuTitle>
        <Input
          className="query-input"
          type="text"
          placeholder="Digite aqui para buscar um produto..."
          onChange={(e) => {
            setProductNameInputSearch(e.target.value);
          }}
        />
        {isUserTyping && productNameInputSearch.length >= 3 ? (
          <Loading
            $NoBg
            color="#fff"
            txt={`Buscando produto ${productNameInputSearch}...`}
          />
        ) : !isUserTyping && productNameInputSearch.length >= 3 ? (
          <ProductList
            page={userProductsSearchPage}
            loadMoreCallback={searchUserProducts}
            setCurrentMode={setCurrentMode}
            onListProductClick={onListProductClick}
            onProductDelete={onProductDelete}
            mainRef={mainRef}
            loadingProducts={loadingProducts}
            setSelectedProduct={setSelectedProduct}
          ></ProductList>
        ) : (
          <ProductList
            page={userProductsPage}
            loadMoreCallback={loadUserProducts}
            onListProductClick={onListProductClick}
            setCurrentMode={setCurrentMode}
            onProductDelete={onProductDelete}
            mainRef={mainRef}
            loadingProducts={loadingProducts}
            setSelectedProduct={setSelectedProduct}
          ></ProductList>
        )}
      </main>
    </Container>
  );
}

const ProductList = ({
  page,
  loadMoreCallback,
  onListProductClick,
  setCurrentMode,
  onProductDelete,
  mainRef,
  loadingProducts,
  setSelectedProduct,
}) => {
  return (
    <>
      {page ? (
        <>
          <List className="flex direction-column justify">
            {page.products.map((product, i) => (
              <ProductButtonWrapper>
                <div>
                  <span className="product-count">Produto {i + 1}.</span>
                  <ListProduct
                    product={product}
                    action={() => onListProductClick(product)}
                  />
                </div>
                {
                  <div className="flex min-gap space-between">
                    <Button
                      text={"Editar"}
                      $NoBgColor
                      width="10rem"
                      color="#fff"
                      action={() => {
                        setSelectedProduct(product);
                        setCurrentMode(UPDATE_MODE);
                        scrollIntoStart(mainRef);
                      }}
                      size={"1.2"}
                    />
                    <Button
                      text={"Deletar"}
                      $NoBgColor
                      width="10rem"
                      color="#fff"
                      action={() => onProductDelete(product)}
                      size={"1.2"}
                    />
                  </div>
                }
              </ProductButtonWrapper>
            ))}
          </List>

          <PaginationButton
            color="#fff"
            text="Carregar mais produtos"
            callback={loadMoreCallback}
            totalPages={page.totalPages}
            currentPage={page.pageNumber}
            hasNextPage={page.hasNextPage}
          />
        </>
      ) : (
        loadingProducts && (
          <Loading $NoBg color="#fff" txt={"Carregando produtos"} />
        )
      )}
    </>
  );
};

const UploadForm = ({
  selectedProduct,
  setCurrentMode,
  selectedProductImageSearch,
  onProductImageClick,
  setSelectedProductImageSearch,
  onCreateNewProduct,
  onProductInfoChange,
}) => {
  return (
    <>
      <Button
        $NoBgColor
        $fullWidth
        text="Salvar produto"
        color="#fff"
        width="calc(100% - 3px)"
        action={() => {
          onCreateNewProduct();
        }}
        size="1.4"
      />
      <ProductFormWrapper className="wrapper flex direction-column">
        <span
          className="close-form-span flex align"
          onClick={() => setCurrentMode(undefined)}
        >
          Fechar formulário <IonIcon icon={closeSharp} />
        </span>
        {selectedProduct && selectedProduct.imageURL != "" ? (
          <Image
            url={selectedProduct.displayUrl}
            height="9rem"
            backgroundSize="contain"
            className="product-image"
          />
        ) : (
          <span className="image-span">A imagem do produto aparecerá aqui</span>
        )}
        {selectedProduct && (
          <ProductForm
            prod={selectedProduct}
            currentProductImages={selectedProductImageSearch}
            handleCurrentProductImageUpdate={(image) => {
              onProductImageClick(image, selectedProduct);
            }}
            productIndex={0}
            currentProductId={0}
            currentProductName={selectedProduct?.name}
            downloadingProductImage={false}
            setCurrentProductId={() => {}}
            setCurrentProductImages={setSelectedProductImageSearch}
            setCurrentProductName={() => {}}
            setNoImageFound={() => {}}
            updateProductInfo={(id, field, value) => {
              onProductInfoChange(field, value, selectedProduct);
            }}
            showAdvancedSettingsForCurrentProduct={false}
            wasNoImageFound={false}
          />
        )}
      </ProductFormWrapper>
    </>
  );
};

const UpdateForm = ({
  setCurrentMode,
  setSelectedProduct,
  selectedProduct,
  selectedProductImageSearch,
  setSelectedProductImageSearch,
  onProductImageClick,
  onProductInfoChange,
  onProductUpdate,
}) => {
  return (
    <>
      <Button
        $NoBgColor
        $fullWidth
        text="Atualizar produto"
        color="#fff"
        width="calc(100% - 3px)"
        action={async () => {
          await onProductUpdate();
          setCurrentMode(null);

          setSelectedProduct(null);
        }}
        size="1.4"
      />
      <ProductFormWrapper className="wrapper flex direction-column">
        <span
          className="close-form-span flex align"
          onClick={() => setCurrentMode(null)}
        >
          Fechar formulário <IonIcon icon={closeSharp} />
        </span>
        <div className="product-image-wrapper flex justify align">
          {selectedProduct && selectedProduct.imageURL != "" ? (
            <Image
              url={selectedProduct.displayUrl}
              height="9rem"
              backgroundSize="contain"
              className="product-image"
            />
          ) : (
            "A imagem do produto aparecerá aqui"
          )}
        </div>
        <ProductForm
          prod={selectedProduct}
          currentProductImages={selectedProductImageSearch}
          handleCurrentProductImageUpdate={(image) => {
            onProductImageClick(image, selectedProduct);
          }}
          productIndex={0}
          currentProductId={0}
          currentProductName={selectedProduct.name}
          downloadingProductImage={false}
          setCurrentProductId={() => {}}
          setCurrentProductImages={setSelectedProductImageSearch}
          setCurrentProductName={() => {}}
          setNoImageFound={() => {}}
          updateProductInfo={(id, field, value) => {
            onProductInfoChange(field, value, selectedProduct);
          }}
          showAdvancedSettingsForCurrentProduct={false}
          wasNoImageFound={false}
        />
      </ProductFormWrapper>
    </>
  );
};
